import {
  ContentCopy as ContentCopyIcon,
  Edit as EditIcon,
  Insights as InsightsIcon,
  Preview as PreviewIcon,
} from '@mui/icons-material';
import { IconButton, Switch, Tooltip } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ContactCapture } from '../../types';

type Props = {
  mutationLoading: boolean;
  record: ContactCapture;
  onDuplicate: (record: ContactCapture) => void;
  onPreview: (record: ContactCapture) => void;
  onStatusChange: (record: ContactCapture) => void;
};

export const ContactCaptureRowActions = ({
  mutationLoading,
  onDuplicate,
  onPreview,
  onStatusChange,
  record,
}: Props) => {
  const navigate = useNavigate();

  return (
    <>
      <Tooltip title="Edit">
        <IconButton size="small" color="primary" aria-label={`Edit ${record.name}`} onClick={() => navigate(`/contact-capture/${record.id}/edit`)}>
          <EditIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Test / Preview">
        <IconButton size="small" color="primary" aria-label={`Test or preview ${record.name}`} onClick={() => onPreview(record)}>
          <PreviewIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Analytics">
        <IconButton size="small" color="primary" aria-label={`View analytics for ${record.name}`} onClick={() => navigate(`/contact-capture/${record.id}/analytics`)}>
          <InsightsIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Duplicate">
        <IconButton size="small" color="primary" aria-label={`Duplicate ${record.name}`} onClick={() => onDuplicate(record)}>
          <ContentCopyIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Tooltip title={record.status === 'active' ? 'Deactivate' : 'Activate'}>
        <Switch
          size="small"
          checked={record.status === 'active'}
          disabled={mutationLoading}
          inputProps={{ 'aria-label': `${record.status === 'active' ? 'Deactivate' : 'Activate'} ${record.name}` }}
          onChange={() => onStatusChange(record)}
        />
      </Tooltip>
    </>
  );
};

